import { PdsWidget } from '../../pds-widget';
import { TextFilter } from '../../models/grid-widget/text-filter';
import { TextField } from '../../models/grid-widget/text-field';
import { ComparatorSetting } from '../../models/grid-widget/grid-widget-filter';
import { SelectOption } from '../../interfaces/select-option';
import { pdsI18n } from '../../pds-i18n';
import { pdsLogger } from '../../pds-logger';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('gridWidget'), 'pds-gw-text-filter.ts');

export class PdsGwTextFilter extends PdsWidget {
  is = 'pds-gw-text-filter';

  //Input
  id: string | null = null;

  //Input
  filter: TextFilter | null = null;

  comparator: 'CONTAINS' | 'IS_BLANK' = 'CONTAINS';

  properties = {
    filter: {
      observer: 'updateComparator',
      value: null
    },
    id: {
      type: String,
      value: null
    }
  };

  ready(): void {
    super.ready();
    this.updateComparator();
  }

  // Sets the local comparator from the filter's comparator.
  // We access comparator in the template rather than filter.comparator so that we will get good change
  // detection.
  updateComparator(): void {
    log('updateComparator called');
    if (this.filter != null) {
      this.comparator = this.filter.comparator;
    }
  }

  attached(): void {
    log('attached called');
    super.attached();
    let contentElement: HTMLElement | null = this.querySelector('.pds-gw-text-filter-content');
    if (contentElement != null) {
      //We listen for this event on the container level because the text widget may or may not be
      //in the dom, but the pds-gw-text-filter-content element will be in the DOM for sure.
      contentElement.addEventListener('modelValueChange', (event: Event) => {
        if (this.filter != null) {
          this.filter.searchValue = (event.target as any).modelValue;
          this.inputChange();
        }
      });
    }
  }

  inputChange(): void {
    log('inputChange called');
    let selectEl: HTMLSelectElement = <HTMLSelectElement>this.querySelector('select');
    if (this.filter != null && selectEl != null) {
      this.filter.comparator = <'CONTAINS' | 'IS_BLANK'>selectEl.value;
      this.updateComparator();
    }

    let event: Event = new Event('renderedElementValueChange', {bubbles: true});
    this.dispatchEvent(event);
  }

  getValidationRule(attributeName: string): string | null {
    log('getValidationRule called');
    if (this.filter != null &&
       this.filter.dataField != null &&
       this.filter.dataField.validationRules != null) {
      return this.filter.dataField.validationRules[attributeName];
    }
    return null;
  }

  getSelectOptions(): Array<SelectOption> {
    log('getSelectOptions called');
    if (this.filter == null) {
      return [];
    }

    return (<TextField>this.filter.dataField).comparatorSettings.array.map((comparatorSetting: {key: string, value: ComparatorSetting}) => {
      return {
        text: pdsI18n.getText(comparatorSetting.value.messageKey),
        value: comparatorSetting.value.comparator
      };
    });
  }
}
